import React, { useRef, useState } from "react";
import "./contact.css";
import { GrLinkedin, GrSkype, GrInstagram, GrMail } from "react-icons/gr";
import { GoCheck } from "react-icons/go";
import { VscError } from "react-icons/vsc";
import Input from "../Input/Input";
import emailjs from "emailjs-com";
import { FormattedMessage } from "react-intl";

const Contact = () => {
  const form = useRef<HTMLFormElement>(null);
  const [send, setsend] = useState(false);
  const [errorMail, setErrorMail] = useState(false);
  const [loading, setloading] = useState(false);

  const sendEmail = (e: any) => {
    e.preventDefault();
    if (form.current) {
      setloading(true);
      emailjs
        .sendForm("service_t7u914j", "template_9rx5wo3", form.current, "user_mBqJt7JCUPnMpzXHspYqH")
        .then(() => {
          setsend(true);
          setTimeout(() => setsend(false), 4000);
        })
        .catch(() => {
          setErrorMail(true);
          setTimeout(() => setErrorMail(false), 4000);
        })
        .finally(() => setloading(false));
    }
  };

  return (
    <section id="contact" className="contact-wrapper">
      <div className="container contact-content">
        <div>
          <h1 className="title"><FormattedMessage id="contact.title" defaultMessage="Contact me" /></h1>
          <h3 className="text-yellow-with-line"><FormattedMessage id="contact.getin" defaultMessage="Get in touch." /></h3>
          <p className="text-call-me">
            <FormattedMessage id="contact.fill" defaultMessage="Fill out our form or call" />
            <br />
            <a href="tel:+261341568408" className="phone">
              +261 34 15 684 08
            </a>
            <FormattedMessage id="contact.tobegin" defaultMessage="to begin." />
          </p>
          <div className="icon-network">
            <a href="https://www.linkedin.com/in/ny-nivoarijaona-1ab4b018b/" rel="noreferrer" target="_blank">
              <GrLinkedin size="1.8em" />
            </a>
            <a href="https://join.skype.com/invite/LyaO7501SwY3" rel="noreferrer" target="_blank">
              <GrSkype size="1.8em" />
            </a>
            <a href="mailto:nynivoarijaona@gmail.com" rel="noreferrer" target="_blank">
              <GrMail size="2em" />
            </a>
            <a href="https://www.instagram.com/nyxd22/" rel="noreferrer" target="_blank">
              <GrInstagram size="1.8em" />
            </a>
          </div>
        </div>
        <div className="form-contact wow bounceIn">
          <h3><FormattedMessage id="contact.sayhello" defaultMessage="Say Hello !" /></h3>
          <form ref={form} onSubmit={sendEmail}>
            <Input label={<FormattedMessage id="form.firstname" defaultMessage="Your first name" />} type="text" required name="user_first_name" />
            <Input label={<FormattedMessage id="form.name" defaultMessage="Your name" />} type="text" name="user_name" />
            <Input label="Email" type="email" name="user_email" />
            <Input label={<FormattedMessage id="form.subject" defaultMessage="Subject" />} type="text" name="user_subject" />
            <Input label="Message" type="textarea" name="user_message" />
            <button type="submit" disabled={loading} className="btn-send">
              {loading ? <div className="square squareInBtn"></div> : <FormattedMessage id="form.send" defaultMessage="Send" />}
            </button>
            {send ? (
              <span className="notif-sucess">
                <GoCheck size="1.4em" />
                <FormattedMessage id="mail.send" defaultMessage="Mail sent!" />
              </span>
            ) : (
              ""
            )}

            {errorMail ? (
              <span className="notif-error">
                <VscError size="1.4em" />
                <FormattedMessage id="mail.notsend" defaultMessage="Mail not sendt!" />
              </span>
            ) : (
              ""
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
